<template>
<w-sliding-popup ref='slidingPopup' title='설정' width='350px'>
  <w-perf-sliding-popup-view slot='content' :selected-node='objInfo' />
</w-sliding-popup>
</template>

<script>
import MapConst from '@/constants/topologymap';
import WPerfSlidingPopupView from '@/views/performance/node/popup/PerfSlidingPopupView';

export default {
  name: 'WDeviceControlPopup',
  components: {
    WPerfSlidingPopupView,
  },
  data() {
    return {
      objInfo: {},
    };
  },
  created() {
    this.$mapEventBus.$on(MapConst.MAP_EVENTBUS.DEVICE_CONTROL, this.open);
  },
  beforeDestroy() {
    this.$mapEventBus.$off(MapConst.MAP_EVENTBUS.DEVICE_CONTROL, this.open);
  },
  methods: {
    /**
     * 팝업 오픈 요청
     * @author KangBonghun(toto1323)
     * @param  {[type]} params [description]
     */
    open(objInfo) {
      this.objInfo = objInfo;

      this.$refs.slidingPopup.open();
    },
    /**
     * 팝업 닫기 요청
     * @author KangBonghun(toto1323)
     */
    close() {
      this.$refs.slidingPopup.close();

      this.objInfo = {};
    },
  },
};
</script>

<style module>
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/popup/DeviceControlPopup.vue